import React from "react";
import { motion } from "framer-motion";
import StatCard from "./StatCard";

const statData = [
  {
    title: "Courses in progress",
    value: "7",
    icon: "courses",
    color: "bg-[#FF9800]",
    textColor: "text-[#4F4F4F]",
  },
  {
    title: "Activités",
    value: "12",
    icon: "activity",
    color: "bg-[#FF9800]",
    textColor: "text-[#4F4F4F]",
  },
  {
    title: "Training Heure",
    value: "3h 15mn",
    icon: "time",
    color: "bg-[#FF9800]",
    textColor: "text-[#4F4F4F]",
  },
  {
    title: "Score",
    value: "240",
    icon: "score",
    color: "bg-[#FF9800]",
    textColor: "text-[#4F4F4F]",
  },
];

const Statscards = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 justify-center gap-4 py-3">
      {statData.map((item, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: index * 0.1 }}
          className="flex justify-center"
        >
          <StatCard
            title={item.title}
            value={item.value}
            icon={item.icon}
            color={item.color}
            textColor={item.textColor}
          />
        </motion.div>
      ))}
    </div>
  );
};

export default Statscards;
